import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { URLSearchParams } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { User } from '../../models/user';
import { ENV } from '../../environments/environment';

@Injectable()
export class UsersService {
  private resourceEndpoint: string;
  public User: User;

  all(): Observable<User[]> {
    return this.http.get<any>(this.resourceEndpoint)
      .map(response => response.data);
  }

  roles(): Observable<any[]> {
    return this.http.get<any>(this.resourceEndpoint+"/roles")
      .map(response => response.data);
  }

  getById(id, requestParams?: any): Observable<any> {
    requestParams = typeof requestParams === "object" ? requestParams : {};

    let queryParams = new URLSearchParams();

    for(let key in requestParams)
    {
      queryParams.set(key, requestParams[key]);
    }

    return this.http.get<any>(`${this.resourceEndpoint}/${id}?` + queryParams.toString())
      .map(response => response.data);
  }

  search(searchParams: object): Observable<any[]> {
    let queryParams = new URLSearchParams();

    for(let key in searchParams)
    {
      queryParams.set(key, searchParams[key]);
    }

    return this.http.get<any>(`${this.resourceEndpoint}?` + queryParams.toString())
      .map(response => response.data);
  }

  create(createParams: object): Observable<any> {
    return this.http.post<any>(`${this.resourceEndpoint}`,createParams)
      .map(response => response.data);
  }

  update(id: number, updateParams: object): Observable<any> {
    return this.http.put<any>(`${this.resourceEndpoint}/${id}`,updateParams)
      .map(response => response.data);
  }

  set(Model) {
    this.User = Model;
  }

  get() {
    return this.User;
  }

  constructor(public http: HttpClient) {
    this.resourceEndpoint = `${ENV.apiUrl}/v${ENV.apiVersion}/users`;
  }
}



// WEBPACK FOOTER //
// ./src/services/users/users-service.ts